import { render, staticRenderFns } from "./SelectAlertX.vue?vue&type=template&id=a0cea4ea&scoped=true&"
import script from "./SelectAlertX.vue?vue&type=script&lang=js&"
export * from "./SelectAlertX.vue?vue&type=script&lang=js&"
import style0 from "./SelectAlertX.vue?vue&type=style&index=0&id=a0cea4ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cea4ea",
  null
  
)

export default component.exports